import { useMemo } from 'react';

import { extractCoreLabels } from 'src/apps/dashboard/helpers/ConfigurationProcessingHelpers';
import {
	DEFAULT_ENVIRONMENT_DISPLAY_NAME,
	ENVIRONMENT_LABEL_KEY
} from 'src/common/consts/platformConfigConsts';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';
import { ConfigurationLabel } from 'src/common/types/ConfigurationTypes';

interface EnvironmentConfig {
	environmentDisplayName: string;
	environmentLabelConfig?: ConfigurationLabel;
}

/**
 * Hook to extract environment label configuration from platform configuration
 * @returns Environment display name and label config
 */
export const useEnvironmentConfig = (): EnvironmentConfig => {
	const { configuration } = useConfiguration();

	return useMemo(() => {
		if (!configuration?.PLATFORM) {
			return {
				environmentDisplayName: DEFAULT_ENVIRONMENT_DISPLAY_NAME,
				environmentLabelConfig: undefined
			};
		}

		const coreLabels = extractCoreLabels(configuration.PLATFORM);
		const environmentLabel = coreLabels.find((label) => label.label === ENVIRONMENT_LABEL_KEY);

		return {
			environmentDisplayName: environmentLabel?.displayName || DEFAULT_ENVIRONMENT_DISPLAY_NAME,
			environmentLabelConfig: environmentLabel
		};
	}, [configuration]);
};
